import $http from '../../axios';
import {Notification} from "element-ui";

export async function fetchPharexReport({ state, commit }) {
    await $http
        .get("/api/reporte-pharex", { params : state.params})
        .then(response => {
            commit("PharexReport", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}



// WEBPACK FOOTER //
// ./src/modules/report-pharex/actions.js